import React from "react";
import { Button } from "../button/button";
import { Tooltip, TooltipProps } from "../tooltip/tooltip";
import "./button-with-tooltip.scss";

export interface ButtonWithTooltipProps extends React.ComponentProps<typeof Button> {
  /** Content shown on hover or focus, including when the button is disabled. */
  tooltipContent: React.ReactNode;
  /** Whether to enable the tooltip. @default true */
  showTooltip?: boolean;
  /** Tooltip placement, delay, sizing, styling, and optional controlled state. */
  tooltipProps?: Omit<TooltipProps, "children" | "content">;
}

/** A Button with a tooltip trigger that remains interactive when disabled. */
export function ButtonWithTooltip({
  tooltipContent,
  tooltipProps,
  showTooltip = true,
  ...buttonProps
}: ButtonWithTooltipProps) {
  if (!showTooltip) return <Button {...buttonProps} />;

  return (
    <Tooltip {...tooltipProps} content={tooltipContent}>
      <span
        className="button-with-tooltip"
        tabIndex={buttonProps.disabled ? 0 : undefined}
      >
        <Button {...buttonProps} />
      </span>
    </Tooltip>
  );
}
